import moment from 'moment';

export default class ProcessLinkedinPostInfo {
  private _publishedBy: string;
  private _publishedDate: moment.Moment | null;
  
  public constructor(data: any) {
    this._publishedBy = data.publishedBy;
    this._publishedDate = moment.utc(data.publishedDate);
  }
  
  public get publishedBy(): string {
    return this._publishedBy;
  }

  public set publishedBy(value: string) {
    this._publishedBy = value;
  }

  public get publishedDate(): moment.Moment | null {
    return this._publishedDate;
  }

  public set publishedDate(value: moment.Moment | null) {
    this._publishedDate = value;
  }
  
}
